import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../store';

export const getVipTasksSelector = (state: RootState) => state.vipSystemSliceReducer.vipTasks;

export const getVipTaskItemsMapSelector = (state: RootState) => state.vipSystemSliceReducer.vipTaskItemsMap;

export const getVipTaskItemsByTaskIdSelector = (vipTaskId: string) =>
  createSelector(getVipTaskItemsMapSelector, (vipTaskItemsMap) => {
    return vipTaskItemsMap.get(vipTaskId) ?? [];
  });

export const getVipLevelsSelector = (state: RootState) => state.vipSystemSliceReducer.vipLevels;

export const getVipLevelRewardsMapSelector = (state: RootState) => state.vipSystemSliceReducer.vipLevelRewardsMap;

export const getVipLevelRewardsByLevelIdSelector = (vipLevelId: string) =>
  createSelector(getVipLevelRewardsMapSelector, (vipLevelRewardsMap) => {
    return vipLevelRewardsMap.get(vipLevelId) ?? [];
  });
